import { createSlice } from "@reduxjs/toolkit";

const accountSlice = createSlice({
  name: "account",
  initialState: {
    urn: null,
    slug: null,
    name: null,
    extraData: null,
    clientUrn: null,
    businessUrn: null,
    businessSlug: null,
  },
  reducers: {
    setSelectedAccount(state, action) {
      const { urn, slug, name, extraData, clientUrn } = action.payload;
      state.urn = urn;
      state.slug = slug;
      state.name = name;
      state.extraData = extraData;
      state.clientUrn = clientUrn;
    },
    clearSelectedAccount(state) {
      state.urn = null;
      state.slug = null;
      state.name = null;
      state.extraData = null;
      state.clientUrn = null;
      state.businessUrn = null;
      state.businessSlug = null;
    },
    updateBusinessUrn(state, action) {
      const { businessUrn, businessSlug } = action.payload;

      state.businessSlug = businessSlug;
      state.businessUrn = businessUrn; // Update the businessUrn in the state
    },
  },
});

// Export actions
export const { setSelectedAccount, clearSelectedAccount, updateBusinessUrn } =
  accountSlice.actions;

// Export reducer
export default accountSlice.reducer;
